import { useCallback, useState } from "react";

const ENABLED_KEY = "timerSoundEnabled";
const LEAD_SECONDS_KEY = "timerSoundWarningLeadSeconds";
const DEFAULT_LEAD_SECONDS = 30;

export const WARNING_LEAD_OPTIONS = [5, 10, 30, 60, 120].map((seconds) => ({
  seconds,
  // An i18n key and its placeholders: "30 seconds", "2 minutes".
  label:
    seconds < 60
      ? ["warningLead.seconds", { count: seconds }]
      : ["warningLead.minutes", { count: seconds / 60 }],
}));

function readEnabled() {
  try {
    const raw = window.localStorage.getItem(ENABLED_KEY);
    return raw === null ? true : raw === "true";
  } catch {
    return true;
  }
}

function readLeadSeconds() {
  try {
    const raw = Number(window.localStorage.getItem(LEAD_SECONDS_KEY));
    return WARNING_LEAD_OPTIONS.some((option) => option.seconds === raw)
      ? raw
      : DEFAULT_LEAD_SECONDS;
  } catch {
    return DEFAULT_LEAD_SECONDS;
  }
}

// Whether timer sounds play, and how far ahead the warning fires, are
// per-browser preferences - unlike the agenda/starttime, they aren't part
// of the shareable link, so they live in localStorage instead of the URL.
export default function useSoundSettings() {
  const [enabled, setEnabledState] = useState(readEnabled);
  const [warningLeadSeconds, setWarningLeadSecondsState] = useState(
    readLeadSeconds
  );

  const setEnabled = useCallback((value) => {
    setEnabledState(value);
    try {
      window.localStorage.setItem(ENABLED_KEY, String(value));
    } catch {
      // localStorage unavailable (e.g. private browsing) - keep it in memory only
    }
  }, []);

  const setWarningLeadSeconds = useCallback((value) => {
    setWarningLeadSecondsState(value);
    try {
      window.localStorage.setItem(LEAD_SECONDS_KEY, String(value));
    } catch {
      // ignore
    }
  }, []);

  return { enabled, setEnabled, warningLeadSeconds, setWarningLeadSeconds };
}
